export var RetrieveApp;
(function (RetrieveApp) {
    RetrieveApp["None"] = "None";
    RetrieveApp["Common"] = "Common";
    RetrieveApp["Lku"] = "Lku";
    RetrieveApp["Ntb"] = "Ntb";
})(RetrieveApp || (RetrieveApp = {}));
export var RegistrationStages;
(function (RegistrationStages) {
    RegistrationStages["None"] = "None";
    RegistrationStages["UserData"] = "User_data";
    RegistrationStages["ChooseSign"] = "Choose_sign";
    RegistrationStages["QuestionareLegalEntity"] = "Questionnaire_legal_entity";
    RegistrationStages["RegistrationFinished"] = "Registration_finished";
})(RegistrationStages || (RegistrationStages = {}));
export var CRMStages;
(function (CRMStages) {
    CRMStages["UserData"] = "user_data";
    CRMStages["ChooseSign"] = "choose_sign";
    CRMStages["QuestionareLegalEntity"] = "questionnaire_legal_entity";
    CRMStages["RegistrationFinished"] = "registration_finished";
})(CRMStages || (CRMStages = {}));
